import { type ApiRoleStrategy, ROLES } from "@pharmupp/p3-front-commons"

const commonApiRoleConf = {
  endpoint: "/api/news/my-event/my-agenda",
  queryKey: ["news", "agenda", "adherent"],
}
export const apiRoleConf = (id?: string): ApiRoleStrategy => ({
  [ROLES.ADHERENT_HOLDER]: commonApiRoleConf,
  [ROLES.ADHERENT_TEAM]: commonApiRoleConf,
  [ROLES.UPP_PRESIDENT]: commonApiRoleConf,
  [ROLES.UPP_REPRESENTATIVE]: commonApiRoleConf,
  ...(id && {
    [ROLES.ADHERENT_ADVISOR]: {
      endpoint: `/api/news/my-sector/${id}/agenda`,
      queryKey: ["news", "agenda", "adherent", id],
    },
    // TODO In production there are calls to "undefined/agenda" - we must investigate why admin is calling agenda with undefined id
    [ROLES.ADMIN]: {
      endpoint: `/api/news/event/adherent/${id}/agenda`,
      queryKey: ["news", "agenda", "adherent", id],
    },
  }),
})
